<template>
    <div>
        <!--<div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-12">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                </div>
                &lt;!&ndash;<div class="col-12 col-md-4 col-lg-2 text-center">
                    <button class="btn btn-primary" @click="onModalShow">مشاهده فاکتور</button>
                    <button class="btn btn-success ml-2" @click="onModalShow">پرداخت</button>
                </div>&ndash;&gt;
            </div>
        </div>-->
        <div class="row mt-3">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-12 col-md-6 col-lg-6">
                <div class="card archive radius">
                    <div class="card-header bg-danger-grad glow-danger radius">
                        <h2 class="text-center text-white">خرید</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-sm-6 product-container" v-for="(item, index) in vouchersBuy">
                                <div :class="{active: item.unitVal > 0}" class="card temp-voucher mt-2 mb-2" @click="onCardClicked($event, index, 'buy')">
                                    <div v-if="item.voucherProductDto !== undefined" class="card-body">
                                        <div class="row p-2">
                                            <div class="col-12">
                                                <div class="text-info">
                                                    <h5 class="d-inline">طرف حساب: </h5>
                                                    <h5 class="d-inline">{{item.outSourceName}}</h5>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <span>توضیحات: </span>
                                                <span>{{item.description}}</span>
                                                <br>
                                                <span>محصولات: </span>
                                                <div v-if="item.voucherProductDto.length < 10">
                                                    <span v-for="product in item.voucherProductDto" class="badge badge-info bg-info-grad m-1"> {{product.productName}} </span>
                                                </div>
                                                <div v-else>
                                                    <span v-for="product in item.voucherProductDto.slice(0, 10)" class="badge badge-info bg-info-grad m-1"> {{product.productName}} </span>
                                                    <span>...</span>
                                                </div>
                                                <br>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-lg-12 text-center mt-3" v-if="vouchersBuy === null || vouchersBuy.length < 1">
                                <h3 class="no-item-alert">سندی در بایگانی یافت نشد!</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="card archive radius">
                    <div class="card-header bg-success-grad glow-success radius">
                        <h2 class="text-center text-white">فروش</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-sm-6 product-container" v-for="(item, index) in vouchersSell">
                                <div :class="{active: item.unitVal > 0}" class="card temp-voucher mt-2 mb-2" @click="onCardClicked($event, index, 'sell')">
                                    <div v-if="item.voucherProductDto !== undefined" class="card-body">
                                        <div class="row p-2">
                                            <div class="col-12">
                                                <span>توضیحات: </span>
                                                <span>{{item.description}}</span>
                                                <br>
                                                <span>محصولات: </span>
                                                <div v-if="item.voucherProductDto.length < 10">
                                                    <span v-for="product in item.voucherProductDto" class="badge badge-info bg-info-grad m-1"> {{product.productName}} </span>
                                                </div>
                                                <div v-else>
                                                    <span v-for="product in item.voucherProductDto.slice(0, 10)" class="badge badge-info bg-info-grad m-1"> {{product.productName}} </span>
                                                    <span>...</span>
                                                </div>
                                                <br>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 text-center mt-3" v-if="vouchersSell === null || vouchersSell.length < 1">
                                <h3 class="no-item-alert">سندی در بایگانی یافت نشد!</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <!--<div v-if="vouchersBuy.length > 17" class="col-lg-12 text-center" @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>-->
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th class=" text-nowrap">نام محصول</th>
                                        <th v-if="isBuyVoucher" class="text-center text-nowrap">قیمت خرید</th>
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <th class="text-center text-nowrap">قیمت فروش</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="voucher !== undefined">
                                    <tr v-for="(item,index) in voucher.voucherProductDto">
                                        <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                        <td>{{item.productName}}</td>
                                        <td v-if="isBuyVoucher" class="text-center">
                                            {{item.price.toLocaleString()}}
                                        </td>
                                        <td class="text-center">
                                            {{item.unitVal}}
                                        </td>
                                        <td class="text-center">
                                            {{item.salesPrice.toLocaleString()}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5" v-if="voucher !== undefined && voucher.voucherProductDto.length < 1">محصولی ثبت نشده است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description" placeholder="توضیحات" disabled>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-danger" @click="onVoucherRemoveClicked">حذف</button>
                            <button type="button" class="btn btn-primary" @click="onModalEditClicked">ویرایش</button>
                            <button type="button" class="btn btn-success" @click="onModalOk">پرداخت</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    $(function() {
        var pos1 = 0;
        $(window).scroll(function() {
            var pos2 = $(window).scrollTop();
            if(pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if(pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(()=> {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'open-buy-archive',
        components: {},
        data() {
            return {
                vouchersBuy: [],
                vouchersSell: [],
                categories: [],
                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    name: "",
                    outsourceId: 0,
                    showAll: false
                },
                searchString: "",
                modalProductName: "",
                cart: [],
                voucher: {
                    description: "",
                    serveOutSourceId: 0,
                    voucherProductDto: []
                },
                tempVoucher: [],
                selectedVoucherIndex: 0,
                isBuyVoucher: false,

                userId: 0,
                companyId: 0
            }
        } ,
        mounted() {
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");
            this.vouchersBuy = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
            this.vouchersSell = JSON.parse(localStorage.getItem(`tempVoucherSell${this.userId}${this.companyId}`));
            $("#loading").hide();

            /*this.voucher = this.vouchersBuy[0];
            let obj = {
                name: 'buy-from-outsource',
                params: {
                    id: this.voucher.serveOutSourceId,
                    voucher: {}
                }
            };
            obj.params.voucher = this.voucher;
            this.$router.push(obj);*/

        },
        methods: {
            onCardClicked(e, index, type) {
                if (type === 'buy') {
                    this.isBuyVoucher = true;
                    this.voucher = this.vouchersBuy[index];
                    Vue.set(this.voucher, "type", "buy");
                    Vue.set(this.voucher, "voucherIndex", this.selectedVoucherIndex);
                } else {
                    this.isBuyVoucher = false;
                    this.voucher = this.vouchersSell[index];
                    Vue.set(this.voucher, "type", "sell");
                    Vue.set(this.voucher, "voucherIndex", this.selectedVoucherIndex);
                }
                this.selectedVoucherIndex = index;
                $("#voucherData").modal("show");
            },
            onModalShow() {
                $("#voucherData").modal("show");
            },
            onModalOk() {
                $("#voucherData").modal("hide");
                if (this.voucher.type === "buy") {
                    let obj = {
                        name: 'payment',
                        params: {
                            voucher: this.voucher,
                            type: "buy"
                        }
                    };
                    this.$router.push(obj);
                } else {
                    let obj = {
                        name: 'payment',
                        params: {
                            voucher: this.voucher,
                            type: "sell"
                        }
                    };
                    this.$router.push(obj);
                }
            },
            onModalEditClicked() {
                $("#voucherData").modal("hide");
                if (this.voucher.type === "buy") {
                    let obj = {
                        name: 'buy-from-outsource',
                        params: {
                            id: this.voucher.serveOutSourceId,
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                } else {
                    let obj = {
                        name: 'sell',
                        params: {
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                }
            },
            onVoucherRemoveClicked() {
                if (confirm("آیا از حذف این سند اطمینان دارید؟")) {
                    if (this.voucher.type === "buy") {
                        this.vouchersBuy.splice(this.selectedVoucherIndex, 1);
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.vouchersBuy));
                    } else {
                        this.vouchersSell.splice(this.selectedVoucherIndex, 1);
                        localStorage.setItem(`tempVoucherSell${this.userId}${this.companyId}`, JSON.stringify(this.vouchersSell));
                    }
                    this.$noty.warning("سند با موفقیت حذف شد!");
                    $("#voucherData").modal("hide");
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>